import React, { useContext } from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import {
  StyledTableCell,
  StyledTableRow,
} from "components/atoms/table/StyledTable";
import Paper from "@mui/material/Paper";

import { LocationTypeContext, AccessContext } from "context/CommonProvider";

const LocationTable = (props) => {
  const navigate = useNavigate();

  const rows = props.rows;
  const rowsLength = rows.length;

  const handleClickView = (event) => {
    navigate(`/local/${event.currentTarget.id}`);
  };

  const locationTypeContext = useContext(LocationTypeContext);
  const accessContext = useContext(AccessContext);

  if (rowsLength === 0) {
    return (
      <Typography sx={{ color: "error.main" }}>
        Erro ao carregar a tabela
      </Typography>
    );
  } else {
    const cells = rows.map((row) => (
      <StyledTableRow
        key={row.id}
        id={row.id}
        onClick={handleClickView}
        sx={{
          "&:hover": {
            cursor: "pointer",
          },
        }}
      >
        <StyledTableCell>{row.numero}</StyledTableCell>
        <StyledTableCell>{row.nome}</StyledTableCell>
        <StyledTableCell>
          {locationTypeContext[row.idLocalTipo]}
        </StyledTableCell>
        <StyledTableCell>{accessContext[row.idAcesso]}</StyledTableCell>
        <StyledTableCell>{row.assentos}</StyledTableCell>
      </StyledTableRow>
    ));
    return (
      <Box sx={{ mb: 2 }}>
        <TableContainer component={Paper}>
          <Table size="small" aria-label="tabela de locais">
            <TableHead>
              <StyledTableRow>
                <StyledTableCell>Número</StyledTableCell>
                <StyledTableCell>Nome</StyledTableCell>
                <StyledTableCell>Tipo</StyledTableCell>
                <StyledTableCell>Acesso</StyledTableCell>
                <StyledTableCell>Assentos</StyledTableCell>
              </StyledTableRow>
            </TableHead>
            <TableBody>{cells}</TableBody>
          </Table>
        </TableContainer>
      </Box>
    );
  }
};

LocationTable.propTypes = {
  rows: PropTypes.array.isRequired,
};

export default LocationTable;
